import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { MessageSquare } from "lucide-react";
import { api, toastErr } from "@/lib/api";
import { Card } from "./ui";

export const LogsTab = () => {
  const [sessions, setSessions] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => { api.get("/admin/sessions").then((r) => setSessions(r.data)).catch(toastErr); }, []);
  const open = (s) => { setActive(s); api.get(`/admin/sessions/${s.session_id}`).then((r) => setMsgs(r.data)).catch(toastErr); };

  return (
    <div className="grid md:grid-cols-[300px_1fr] gap-6">
      <Card title={`Sessions (${sessions.length})`} className="md:max-h-[70vh] overflow-y-auto">
        {sessions.length === 0 && <p data-testid="logs-empty" className="text-sm text-slate-500">No conversations yet.</p>}
        <ul className="space-y-1">
          {sessions.map((s) => (
            <li key={s.session_id}>
              <button data-testid="chat-session-item" onClick={() => open(s)} className={`w-full text-left px-3 py-2.5 rounded-xl transition-colors ${active?.session_id === s.session_id ? "bg-slate-900 text-white" : "hover:bg-slate-100"}`}>
                <p className="text-sm font-medium truncate">{s.preview || "(empty)"}</p>
                <p className={`text-xs mt-0.5 ${active?.session_id === s.session_id ? "text-slate-300" : "text-slate-500"}`}>{s.message_count} msgs · {new Date(s.last_at).toLocaleString()}</p>
              </button>
            </li>
          ))}
        </ul>
      </Card>
      <Card title={active ? `Conversation · ${active.session_id.slice(0, 8)}` : "Conversation"} className="md:max-h-[70vh] overflow-y-auto">
        {!active && <div className="text-sm text-slate-500 flex items-center gap-2"><MessageSquare size={16} /> Select a session to read it.</div>}
        <div data-testid="session-messages" className="space-y-3">
          {msgs.map((m, i) => (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] px-3.5 py-2 rounded-2xl text-sm ${m.role === "user" ? "bg-slate-800 text-white" : "md bg-slate-50 border border-slate-200"}`}>
                {m.role === "user" ? m.content : <ReactMarkdown>{m.content}</ReactMarkdown>}
                <p className={`text-[10px] mt-1 ${m.role === "user" ? "text-slate-300" : "text-slate-400"}`}>
                  {new Date(m.created_at).toLocaleTimeString()}{m.latency_ms ? ` · ${m.latency_ms}ms · ${m.tokens} tok` : ""}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
